import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { AD_CONFIG, REMINDER_APP_URL, COLORS } from '../utils/constants';

const { FiTrendingDown, FiExternalLink, FiBell } = FiIcons;

const AdBanner = ({ onClick }) => {
  return (
    <div className="space-y-4">
      
      {/* Main Ad Banner */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl shadow-2xl p-6 text-white border-4"
        style={{ borderColor: COLORS.secondary }}
      >
        <div className="flex flex-col md:flex-row items-center gap-6">
          <div className="flex-shrink-0 text-5xl">
            💰
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-2xl font-bold mb-2">Verbrauch zu hoch?</h3>
            <p className="text-lg opacity-90">
              Jetzt Energiekosten senken und bis zu 500€ pro Jahr sparen!
            </p>
          </div>
          <motion.a
            href={AD_CONFIG.link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex-shrink-0 bg-white px-8 py-4 rounded-lg font-bold shadow-xl hover:shadow-2xl transition-all flex items-center gap-2"
            style={{ color: COLORS.secondary }}
          >
            <SafeIcon icon={FiTrendingDown} size={20} />
            <span>{AD_CONFIG.text}</span>
            <SafeIcon icon={FiExternalLink} size={16} />
          </motion.a>
        </div>
      </motion.div>

      {/* Reminder Service Banner */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="bg-white rounded-xl shadow-lg p-6 border-l-4"
        style={{ borderColor: COLORS.primary }}
      >
        <div className="flex flex-col md:flex-row items-center gap-4">
          <div className="flex-shrink-0 p-3 rounded-full text-white" style={{ backgroundColor: COLORS.primary }}>
            <SafeIcon icon={FiBell} size={28} />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h4 className="text-xl font-bold mb-1" style={{ color: COLORS.primary }}>
              Nie wieder Vertragswechsel verpassen!
            </h4>
            <p className="text-gray-600">
              Kostenloser Erinnerungsdienst - Wir informieren Sie rechtzeitig über Kündigungsfristen
            </p>
          </div>
          <motion.a
            href={REMINDER_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex-shrink-0 px-6 py-3 text-white font-bold rounded-lg shadow-lg hover:shadow-xl transition-all flex items-center gap-2"
            style={{ backgroundColor: COLORS.secondary }}
          >
            <span>Jetzt aktivieren</span>
            <SafeIcon icon={FiExternalLink} size={16} />
          </motion.a>
        </div>
      </motion.div>
    </div>
  );
};

export default AdBanner;